import "./ClassDetails.scss";

import moment from "moment";
import { FlagIcon } from "react-flag-kit";
import { useTranslation } from "react-i18next";
// import { BiSolidError } from "react-icons/bi";
import * as momentTimezone from "moment-timezone";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useNavigate, useParams } from "react-router-dom";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import {
  endLoading,
  initLoading,
  setDemoClass,
  setTeachers,
  clearPreviousClasses,
} from "../../store/slices/generics.slice";
import {
  getNextClasses,
  putClassStatus,
  putCancelClass,
  getFormByFilter,
  getDetailsClass,
  postCancelClass,
  getLastSchedules,
  getPreviousClasses,
  getStudentPlansUser,
  getSequentialClasses,
  getWordofthedayByDate,
  getActiveLanguagesPlan,
  getStudentTeacherRestriction,
  getTeacherWithNativeLanguage,
} from "../../store/middleware";
import DemoClassDetails from "./DemoClassDetails";
import CancelDialog from "../Calendar/CancelDialog";
import { timeDisplayFormat } from "../../utils/utils";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import IconBirthday from "../../assets/images/birthday.png";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import IconAvatar from "../../assets/images/profile/img_placeholder.svg";
import Schedule from "../../assets/images/icons/icon_schedule_header.svg";
import ModalSchedule from "../../components/ScheduleModals/ModalSchedule";
import CardNextClasses from "../../components/classDetails/CardNextClasses";
import CardWordoftheday from "../../components/classDetails/CardWordoftheday";
import ModalQuestionnairesView from "../../components/ModalQuestionnairesView";
import LoadingComponent from "../../components/LoadingComponent/LoadingComponent";
import CardLatestSchedule from "../../components/classDetails/CardLatestSchedule";
import { clearReportStatus, setReport } from "../../store/slices/methodology.slice";
import CardPreviousClasses from "../../components/classDetails/CardPreviousClasses";
import ModalMessageCoordinator from "../../components/classDetails/ModalMessageCoordinator";

function ClassDetails() {
  let { id } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.userReducer);
  const { teachers, allPreviousClasses, allNextClasses } = useSelector((state) => state.genericReducer);

  const [focus, setFocus] = useState("");
  const [planId, setPlanId] = useState(0);
  const [userId, setUserId] = useState(0);
  const [status, setStatus] = useState("");
  const [noShow, setNoShow] = useState(false);
  const [teacherId, setTeacherId] = useState(0);
  const [studentId, setStudentId] = useState(0);
  const [userClass, setUserClass] = useState({});
  const [startTime, setStartTime] = useState("");
  const [classTool, setClassTool] = useState("");
  const [alerttitle, setAlertTitle] = useState("");
  const [openalert, setOpenAlert] = useState(false);
  const [classToolId, setClassToolId] = useState("");
  const [showBtnSave, setShowBtnSave] = useState(false);
  const [scheduledDate, setScheduledDate] = useState("");
  const [allSeqClasses, setAllSeqClasses] = useState([]);
  const [moreClassLimit, setMoreClassLimit] = useState(5);
  const [openSchedule, setOpenSchedule] = useState(false);
  const [lingoLanguageId, setLingoLanguageId] = useState(0);
  const [specificSubject, setSpecificSubject] = useState("");
  const [alerttitleStatus, setAlertTitleStatus] = useState("");
  const [alertdescription, setAlertDescription] = useState("");
  const [cancelAlertOpen, setCancelAlertOpen] = useState(false);
  const [openalertStatus, setOpenAlertStatus] = useState(false);
  const [formByFilterReport, setFormByFilterReport] = useState([]);
  const [recurrentSchedule, setRecurrentSchedule] = useState(false);
  const [recurrentScheduleId, setRecurrentScheduleId] = useState("");
  const [canSeeNoShowSwitch, setCanSeeNoShowSwitch] = useState(false);
  const [sequentialScheduleId, setSequentialScheduleId] = useState("");
  const [classScheduleDetails, setClassScheduleDetails] = useState([]);
  const [scheduledEndDateTime, setScheduledEndDateTime] = useState(null);
  const [showModalCoordinator, setShowModalCoordinator] = useState(false);
  const [scheduledStartDateTime, setScheduledStartDateTime] = useState("");
  const [recurrentScheduleEndDate, setRecurrentScheduleEndDate] = useState("");
  const [showModalQuestionnaires, setShowModalQuestionnaires] = useState(false);
  const [sequentialScheduleCancelClasses, setSequentialScheduleCancelClasses] = useState([]);

  const levelStudent =
    allPreviousClasses?.length > 0 && allPreviousClasses[allPreviousClasses?.length - 1][0]?.cycleAndLevel[0]?.level;

  const customLanguage = userClass && userClass?.lingoLanguage?.customLang;

  const closeCancelAlert = () => setCancelAlertOpen(false);
  const handleOpenModalQuestionnaires = () => setShowModalQuestionnaires(true);

  const cancelSubmit = async (message, cancelledBy, recurrentSchedule, cancelAllRecurrences) => {
    setCancelAlertOpen(false);

    await dispatch(
      postCancelClass(
        getCancelObj(userClass, message, cancelledBy, user?.role, recurrentSchedule, cancelAllRecurrences),
      ),
    );

    navigate(-1);
  };

  const getCancelObj = (schedule, message, cancelledBy, role, recurrentSchedule, cancelAllRecurrences) => {
    if (role === "teacher") {
      return getTeacherCancelObj(schedule, message, cancelAllRecurrences);
    } else {
      return getOthersCancelObj(schedule, recurrentSchedule, message, cancelledBy, cancelAllRecurrences);
    }
  };

  const getTeacherCancelObj = (schedule, message) => {
    const isFixed = schedule.allocationSchedule === "fixed";
    const cancelObj = { reason: message };
    if (isFixed) {
      cancelObj.allocationScheduleId = schedule.allocationScheduleId;
      cancelObj.reschedule = true;
    } else {
      cancelObj.sequentialScheduleId = schedule.sequentialScheduleId;
    }
    return cancelObj;
  };

  const getOthersCancelObj = (schedule, recurrentSchedule, message, cancelledBy, cancelAllRecurrences) => {
    const cancelObj = { reason: message, cancelledBy };
    if (recurrentSchedule && cancelAllRecurrences) {
      cancelObj.recurrentScheduleId = schedule.recurrentScheduleId;
    } else {
      cancelObj.sequentialScheduleId = schedule.sequentialScheduleId;
    }
    return cancelObj;
  };

  const setCancelModalValues = (e) => {
    e.preventDefault();
    const recurrentSchedule = userClass?.recurrentSchedule;
    setCancelAlertOpen(true);
    setRecurrentSchedule(recurrentSchedule);
    getSequentialSchedules(recurrentSchedule, userClass);
  };

  const getSequentialSchedules = (recurrentSchedule, schedule) => {
    schedule && handleGetSequentialClasses(schedule, recurrentSchedule);
  };

  const handleGetSequentialClasses = (schedule, recurrentSchedule) => {
    const pageNumber = 1;
    const pageSize = 100;
    const params = {
      pageNumber,
      pageSize,
      recurrentScheduleId: schedule?.recurrentScheduleId,
      sequentialScheduleId: schedule?.sequentialScheduleId,
    };
    dispatch(getSequentialClasses(params, recurrentSchedule))
      .then((res) => {
        setAllSeqClasses(res);
        setSequentialScheduleCancelClasses(
          res.filter(
            (sequential) =>
              momentTimezone(sequential.scheduledDate).format("YYYY-MM-DD") ===
              momentTimezone(schedule.scheduledDate).format("YYYY-MM-DD"),
          ),
        );
        setRecurrentScheduleEndDate(res[res.length - 1]?.scheduledDate);
        setRecurrentScheduleId(res[0]?.recurrentScheduleId);
      })
      .catch((err) => {
        console.log("ERROR ON GET SEQUENTIAL END DATE: ", err);
      });
  };

  const CancelCardItem = () => {
    if (status && scheduledEndDateTime && scheduledStartDateTime) {
      const isCanceled = status === "canceled";
      const iscanceledFree = status === "canceledFree";
      const isCanceledByLingo = status === "canceledLingo";
      const iscanceledFreeLingo = status === "canceledFreeLingo";
      const isPending = status === "pending";
      const isAccepted = status === "accepted";

      const localTime = getLocalTimeFromUtc(user);
      let canCancel = true;
      //Se for student apenas pode cancelar até o inicio da aula
      canCancel = moment(localTime).isBefore(scheduledStartDateTime);

      if (isCanceled || iscanceledFree || isCanceledByLingo || iscanceledFreeLingo) {
        return (
          <h4 className={"scheduleCanceled"}>
            {t("CLASS_CANCELED_IN")}{" "}
            {user?.role === "student" &&
              moment(userClass.classScheduleDetails[0].updatedAt)
                .tz(userClass?.student?.user.timezone)
                .format(timeDisplayFormat(user?.timeDisplayFormat))}
            {user?.role === "teacher" &&
              moment(userClass.classScheduleDetails[0].updatedAt)
                .tz(userClass?.teacher?.user.timezone)
                .format(timeDisplayFormat(user?.timeDisplayFormat))}
            {(user?.role === "customerService" || user.role === "companyManager") &&
              moment(userClass.classScheduleDetails[0].updatedAt)
                .tz(user?.timezone)
                .format(timeDisplayFormat(user?.timeDisplayFormat))}
          </h4>
        );
      } else if (canCancel) {
        if (isPending || isAccepted) {
          return (
            <button className="cancelSchedule" onClick={setCancelModalValues}>
              {t("BTN_CANCEL")} <i className="fa fa-times-circle-o"></i>
            </button>
          );
        } else {
          return <div className="scheduleCanceled" />;
        }
      } else {
        return <></>;
      }
    } else {
      return <></>;
    }
  };

  const EditCardItem = () => {
    if (status && scheduledEndDateTime && scheduledStartDateTime) {
      const isPending = status === "pending";
      const isAccepted = status === "accepted";

      const localTime = getLocalTimeFromUtc(user);
      let canCancel = true;
      canCancel = moment(localTime).isBefore(scheduledStartDateTime);

      if (canCancel) {
        if (isPending || isAccepted) {
          return (
            <button className="buttonEdit" onClick={() => setOpenSchedule(true)}>
              {t("CLASS_DETAILS_EDIT_CLASS")}
            </button>
          );
        } else {
          return <div className="scheduleCanceled" />;
        }
      } else {
        return <></>;
      }
    } else {
      return <></>;
    }
  };

  function verifyTimeZone(timezone) {
    return timezone === "America/Sao_Paulo" ? "America/Bahia" : timezone;
  }

  const getLocalTimeFromUtc = (user) => {
    return moment.tz(moment(), verifyTimeZone(user.timezone)).utc();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let startime = "";
    let startdate = "";

    if (startTime === "") {
      startime = userClass?.scheduledStartTime;
    } else {
      startime = startTime;
    }
    if (scheduledDate === "") {
      startdate = userClass?.scheduledDate;
    } else {
      startdate = scheduledDate;
    }

    const req = {
      studentId,
      studentPlanId: planId,
      lingoLanguageId: parseInt(lingoLanguageId),
      teacherId: teacherId === 0 ? null : parseInt(teacherId),
      sequentialScheduleId,
      focus,
      scheduledStart: `${momentTimezone(startdate).format("YYYY-MM-DD")}T${startime}.000`,
      numberOfClasses: userClass?.sequentialScheduleClassesCount,
      specificSubject: userClass?.classScheduleDetails[0]?.specificSubject,
      applyToRecurrence: false,
      status: noShow ? "noShow" : teacherId ? "accepted" : "pending",
    };

    if (user?.role === "student") {
      req.teacherId = null;
    }

    dispatch(putCancelClass(req))
      .then((res) => {
        if (res.success) {
          navigate(-1);
        }
      })
      .catch((err) => {
        if (err.response.data.error.httpCode === 409) {
          const lang = localStorage.getItem("i18nextLng");
          const langformatted = lang == "pt" ? "pt_BR" : lang == "en" ? "en_US" : lang == "es" ? "es" : "en_US";

          setOpenAlert(true);
          setAlertTitle(t("ERROR"));
          setAlertDescription(err.response.data.error.message[langformatted]);
        } else {
          setOpenAlert(true);
          setAlertTitle(t("ERROR"));
          setAlertDescription(
            err.response.data.error
              ? err.response.data.error
              : err.response.data.error[0]?.message
              ? err.response.data.error[0]?.message
              : t("SOMETHING_WENT_WRONG"),
          );
        }
      });
  };

  const handleLoadInfos = async () => {
    await dispatch(setDemoClass(null));

    try {
      await dispatch(initLoading());

      const item = await dispatch(getDetailsClass(id, false));

      const localTime = getLocalTimeFromUtc(user);
      const isPastClass = moment(localTime).isAfter(item.scheduledStartDateTime);

      let languageNativeTemp = "";

      if (item?.student && item?.student.studentLanguages.length > 0) {
        item?.student.studentLanguages.map((language) => {
          languageNativeTemp = language.isNative === true ? language.language.name : languageNativeTemp;
        });
      }

      if (item.teacherId !== null) {
        item.teacher.teachers = [];
      }

      setUserClass(item);

      if (item.target !== "demo") {
        setNoShow(item.status === "noShow");
        setCanSeeNoShowSwitch(
          isPastClass &&
            ["coordinator", "customerService", "companyManager"].indexOf(user?.role) >= 0 &&
            item.status !== "canceled" &&
            item.status !== "canceledFree" &&
            item.status !== "canceledLingo" &&
            item.status !== "canceledFreeLingo",
        );
        setSequentialScheduleId(item?.sequentialScheduleId);
        setStartTime(item?.scheduledStartTime);
        if (item.teacherId !== null) {
          setTeacherId(item?.teacherId);
        }

        setStudentId(item?.studentId);
        setPlanId(item?.studentPlanId);
        setUserId(item?.student?.userId);
        setLingoLanguageId(item?.lingoLanguageId);
        // setLanguageNative(languageNativeTemp ? languageNativeTemp : "");
        setFocus(item?.classScheduleDetails[0]?.focus.toLowerCase());
        setSpecificSubject(item?.classScheduleDetails[0].specificSubject);
        setRecurrentSchedule(item?.recurrentSchedule);
        setRecurrentScheduleId(item?.recurrentScheduleId);
        setScheduledDate(momentTimezone(item?.scheduledDate));
        setStatus(item?.status);
        setClassScheduleDetails(item?.classScheduleDetails ? item?.classScheduleDetails : []);
        setClassTool(item?.student ? item?.student.classTool : "");
        setClassToolId(item?.student ? item?.student.classToolId : "");
        // setListSequentialClass(sequentialsClass);
        setScheduledEndDateTime(item?.scheduledEndDateTime);
        setScheduledStartDateTime(item?.scheduledStartDateTime);

        item?.student?.userId && (await dispatch(getStudentPlansUser(item?.student?.userId)));

        if (user?.role !== "student") {
          const payloadClass = {
            studentId: item?.studentId,
            lingoLanguageId: item?.lingoLanguageId,
            sequentialScheduleId: item?.sequentialScheduleId,
          };

          dispatch(getNextClasses(payloadClass));
          dispatch(getLastSchedules(payloadClass));
          dispatch(getPreviousClasses(payloadClass));
          const resTeachers = await dispatch(getTeacherWithNativeLanguage(item?.lingoLanguage?.languageId));

          const payloadFormByFilter = { sequentialScheduleId: item?.sequentialScheduleId };
          dispatch(getFormByFilter(payloadFormByFilter, false)).then((resp) => {
            resp.length > 0 && setFormByFilterReport(resp[0]);
          });

          await loadExceptions(item?.studentId, resTeachers);
        }

        await dispatch(getActiveLanguagesPlan(item?.studentPlanId ? item?.studentPlanId : 0, false)).then((res) => {
          let activeLangs = [];
          if (res.length > 0)
            for (var itemLang in res[0]?.studentPlanLanguages) {
              if (res[0]?.studentPlanLanguages[itemLang].lingoLanguage.active)
                activeLangs.push(res[0]?.studentPlanLanguages[itemLang].lingoLanguage);
            }
          // setLanguages(activeLangs);
        });

        await dispatch(
          getWordofthedayByDate(
            item?.lingoLanguageId === 1
              ? "EN"
              : item?.lingoLanguageId === 2
              ? "ES"
              : item?.lingoLanguageId === 3
              ? "PT"
              : "FR",
            item?.scheduledDate,
          ),
        );
      }
    } catch (err) {
      console.log(err);
    } finally {
      await dispatch(endLoading());
    }
  };

  const loadExceptions = async (id, arrTeachers) => {
    await dispatch(getStudentTeacherRestriction(id))
      .then(async (res) => {
        if (!res) return;

        let tempTeacher = arrTeachers;
        res.map((el) => {
          tempTeacher = tempTeacher.filter((e) => e.teachers[0].id !== el.teacher.id);
        });
        await dispatch(setTeachers(tempTeacher));
      })
      .catch((err) => console.log("ERRO GET getStudentTeacherRestriction ", err));
  };

  const checkBirthdayDate = (birthDate) => {
    const dateToday = moment();
    const dateParameterObj = moment(birthDate);

    return dateToday.isSame(dateParameterObj, "day");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "teacherId") {
      setShowBtnSave(true);
      if (value !== "") {
        const found = teachers.filter((i) => i.teachers[0].id === Number(value));
        const t = found[0];
        const userClassTemp = { ...userClass };

        userClassTemp.teacher = t;
        setUserClass(userClassTemp);
        setTeacherId(userClassTemp?.teacher?.teachers[0]?.id);
      } else {
        const found = teachers.filter((i) => i.teachers[0].id === Number(value));
        const t = found[0];
        const userClassTemp = { ...userClass };

        userClassTemp.teacher = t;
        setUserClass(userClassTemp);
        setTeacherId(value);
      }
    }
    if (name === "noShow") {
      setNoShow(!noShow);
    }

    if (name === "focus") {
      setFocus(value);
    }

    if (name === "specificSubject") {
      setSpecificSubject(value);
    }
  };

  const handleChangeStatus = (name) => {
    if (name === "noShow") {
      setNoShow(!noShow);
      setOpenAlertStatus(true);
      setAlertTitleStatus(t("EDIT"));
    }
  };

  const editTeacherDisabled = () => {
    if (user?.role === "student" || user?.role === "teacher") return true;
    const localTime = getLocalTimeFromUtc(user);
    var scheduledClassDate = momentTimezone(userClass.originalScheduledDateTimeUTC).utc();
    scheduledClassDate = momentTimezone(scheduledClassDate).add(30, "minutes"); //teacher can edit running class
    return momentTimezone(localTime).isAfter(scheduledClassDate) || status === "canceled";
  };

  const handleSubmitStatus = (e) => {
    e.preventDefault();

    const req = {
      sequentialScheduleId,
      status: noShow ? "noShow" : teacherId ? "accepted" : "pending",
    };

    dispatch(putClassStatus(req))
      .then((res) => {
        if (res.success) navigate(-1);
      })
      .catch((err) => {
        if (err.response.data.error.httpCode === 409) {
          const lang = localStorage.getItem("i18nextLng");
          const langformatted = lang == "pt" ? "pt_BR" : lang == "en" ? "en_US" : lang == "es" ? "es" : "en_US";

          setOpenAlert(true);
          setAlertTitle(t("ERROR"));
          setAlertDescription(err.response.data.error.message[langformatted]);
        } else {
          setOpenAlert(true);
          setAlertTitle(t("ERROR"));
          setAlertDescription(err.response.data.error ? err.response.data.error : t("SOMETHING_WENT_WRONG"));
        }
      });
  };

  const ClassToolCardItem = () => {
    const isLink = classToolId && classToolId.indexOf("http") > -1;
    return classTool ? (
      isLink ? (
        <Fragment>
          <button type="submit" className="buttonSave pointer" onClick={() => window.open(classToolId)}>
            {t("CLASS_DETAILS_ACCESS_CLASS")}
          </button>
        </Fragment>
      ) : (
        <Fragment>
          <span className="buttonSave">{classTool}</span>{" "}
          <span style={{ color: "#5A6C96", fontSize: "11px", fontWeight: "500" }}>{classToolId}</span>
        </Fragment>
      )
    ) : (
      ""
    );
  };

  const userTimezoneConvert = (time, userTimezone) => {
    let timezoneUser = momentTimezone.tz(momentTimezone(time).format("YYYY-MM-DD HH:mm"), user?.timezone);
    return timezoneUser.clone().tz(userTimezone?.timezone);
  };

  const handleCalcDuration = (numeroAulas) => {
    let num;
    let hours;
    let rhours;
    let minutes;
    let rminutes;
    num = numeroAulas * 30;
    hours = num / 60;
    rhours = Math.floor(hours);
    minutes = (hours - rhours) * 60;
    rminutes = Math.round(minutes);
    if (rminutes === 0) {
      rminutes = `${rhours}h`;
    } else if (rhours === 0) {
      rminutes = `${rminutes}m`;
    } else {
      rminutes = `${rhours}h:${rminutes}m`;
    }
    return rminutes;
  };

  const handleNavigateReport = async () => {
    if (formByFilterReport?.length === 0) return;

    await dispatch(setReport(formByFilterReport));
    navigate("/report-details");
  };

  const handleMoreContent = () => {
    setMoreClassLimit(10);
  };

  useEffect(() => {
    clearPreviousClasses();
    clearReportStatus();
    handleLoadInfos();
    // eslint-disable-next-line
  }, []);

  if (userClass && userClass.target === "demo") {
    return <DemoClassDetails userClass={userClass} />;
  }

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header
          t={t}
          typeIcon="img"
          initLoadingBoolean={false}
          title={t("CARD_CLASS_DETAILS")}
          icon={<img src={Schedule} alt="Schedule" />}
          leftButton={
            <button className="leftButton" onClick={() => navigate(-1)}>
              {t("BTN_BACK")}
            </button>
          }
        />

        <LoadingComponent />
        {userClass && userClass.id && (
          <div>
            <div key={"classDetail_" + userClass.id} className="container">
              <div className="classDetails">
                {user?.role === "student" && status !== "done" && (
                  <div className="actionBar spaceBetween">
                    <div className="columnClass">
                      {/* <span>{t("CLASS_DETAILS_BEFORE_CLASS")}</span> */}
                      <div className="actionButtons">
                        <EditCardItem />
                        <CancelCardItem />
                      </div>
                    </div>
                    {status !== "canceled" &&
                      status !== "canceledFree" &&
                      status !== "canceledLingo" &&
                      status !== "canceledFreeLingo" && <ClassToolCardItem />}
                    {/* <div className="columnClass">
                      <span>{t("CLASS_DETAILS_BEFORE_CLASS")}</span>
                      <div className="actionButtons">
                      </div>
                    </div> */}
                  </div>
                )}
                {user?.role === "teacher" && (
                  <div className="actionBar">
                    <div className="columnClass">
                      <span>{t("CLASS_DETAILS_BEFORE_CLASS")}</span>
                      <div className="actionButtons">
                        <CancelCardItem />
                        <ClassToolCardItem />
                        {/* <button className="buttonCheckin">Check-in</button> */}
                      </div>
                    </div>
                    {/* <div className="columnClass">
                      <span>Durante a aula</span>
                      <div className="actionButtons">
                        <button className="buttonCheckin">Aluno não chegou</button>length
                        <button className="buttonCheckin">Reportar problema</button>
                      </div>
                    </div> */}
                    {formByFilterReport?.length !== 0 &&
                      (formByFilterReport[0]?.status === "pendent" ||
                        formByFilterReport[0]?.status === "pendent-delayed") && (
                        <div className="columnClass">
                          <span>{t("AFTER_CLASS")}</span>
                          <div className="actionButtons">
                            <button className="buttonCheckin" onClick={handleNavigateReport}>
                              {t("FILL_REPORT")}
                            </button>
                          </div>
                        </div>
                      )}
                    {/*
                    <div className="changeClass">
                      <button className="transparentButton">
                        <i className="fa fa-chevron-left"></i>Aula anterior
                      </button>
                      <button className="transparentButton">
                        Próxima aula<i className="fa fa-chevron-right"></i>
                      </button>
                    </div> */}
                  </div>
                )}
                {(user?.role === "companyManager" || user?.role === "customerService") && (
                  <div className="actionBar">
                    <div className="columnClass">
                      {/* <span>{t("CLASS_DETAILS_BEFORE_CLASS")}</span> */}
                      <div className="actionButtons">
                        <EditCardItem />
                        {user?.role === "companyManager" && (
                          <button
                            style={{ display: "none" }}
                            className="buttonCoordinator"
                            onClick={() => setShowModalCoordinator(true)}
                          >
                            Mensagem do coordenador
                          </button>
                        )}
                        {status !== "done" ? (
                          <select
                            name="teacherId"
                            value={teacherId}
                            onChange={handleChange}
                            className="selectTeachers"
                            disabled={editTeacherDisabled()}
                          >
                            <option value="">Select</option>
                            {teachers.length > 0 &&
                              teachers?.map((itemTeacher) => (
                                <option key={itemTeacher.id * 8} value={itemTeacher.teachers[0].id}>
                                  {decryptIfEncrypted(itemTeacher.name)}
                                </option>
                              ))}
                          </select>
                        ) : (
                          <select
                            onChange={handleChange}
                            name="teacherId"
                            value={teacherId}
                            className="selectTeachers"
                            disabled
                          >
                            <option value="">Select</option>
                            {teachers.length > 0 &&
                              teachers?.map((itemTeacher) => (
                                <option key={itemTeacher.id * 9} value={itemTeacher.teachers[0].id}>
                                  {decryptIfEncrypted(itemTeacher.name)}
                                </option>
                              ))}
                          </select>
                        )}
                        <CancelCardItem />
                        {canSeeNoShowSwitch && (
                          <div className="item">
                            <h3>{t("CARD_CLASS_ATTENDED")}</h3>
                            <div className="switchBox">
                              <div className="switch__container">
                                <input
                                  id="switch-shadow"
                                  className="switch switch--shadow"
                                  name="noShow"
                                  type="checkbox"
                                  checked={noShow}
                                  onChange={() => handleChangeStatus("noShow")}
                                />
                                <label htmlFor="switch-shadow">
                                  <span style={{ marginLeft: "50px", fontSize: "12px" }}>
                                    {noShow ? t("YES") : t("NO")}
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                        )}

                        {showBtnSave && (
                          <div className="divSave">
                            <button className="saveButton" onClick={(e) => handleSubmit(e)}>
                              {t("SAVE")}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {user?.role === "student" && (
                  <div className="listSelect">
                    <div className="rowInfo">
                      {userClass.teacher && status === "done" && (
                        <div className="rowItem timezone">
                          <div className="columnItem">
                            {userClass.teacher && userClass?.teacher?.user?.picture ? (
                              <img className="imgTeacher" src={userClass.teacher.user.picture} alt="" />
                            ) : userClass.teacher && userClass?.teacher?.picture ? (
                              <img className="imgTeacher" src={userClass?.teacher?.picture} alt="" />
                            ) : (
                              <img className="imgTeacher" src={IconAvatar} alt="" />
                            )}
                            {checkBirthdayDate(userClass?.teacher?.user?.birthDate) && (
                              <img className="iconBirthday" src={IconBirthday} alt="" />
                            )}
                          </div>
                          <div className="columnItem dateItem">
                            <span className="nameTeacher">{decryptIfEncrypted(userClass?.teacher?.user?.name)}</span>
                            <span className="infoTeacher green">{t("TEACHER")}</span>
                            {userClass?.teacher?.teacherLanguages
                              ? userClass?.teacher?.teacherLanguages
                                  ?.filter(
                                    (lang) =>
                                      lang.isNative &&
                                      lang.language.name.toUpperCase() ===
                                        userClass?.lingoLanguage?.description.toUpperCase(),
                                  )
                                  ?.map((itemTeacherLang) => {
                                    return (
                                      <span key={JSON.stringify(itemTeacherLang)} className="infoTeacher">
                                        {t("NATIVE_LANGUAGE")}:{" "}
                                        {t(decryptIfEncrypted(itemTeacherLang.language.name).toUpperCase())}
                                      </span>
                                    );
                                  })
                              : userClass?.teacher?.teachers[0]?.teacherLanguages
                                  ?.filter(
                                    (lang) =>
                                      lang.isNative &&
                                      lang.language.name.toUpperCase() ===
                                        userClass?.lingoLanguage?.description.toUpperCase(),
                                  )
                                  ?.map((itemTeacherLang) => {
                                    return (
                                      <span key={JSON.stringify(itemTeacherLang)} className="infoTeacher">
                                        {t("NATIVE_LANGUAGE")}:{" "}
                                        {t(decryptIfEncrypted(itemTeacherLang.language.name).toUpperCase())}
                                      </span>
                                    );
                                  })}
                            <span className="infoTeacher">
                              {t("COUNTRY")}:{" "}
                              {decryptIfEncrypted(
                                userClass?.teacher?.country
                                  ? userClass?.teacher?.country?.name
                                  : userClass?.teacher?.user?.country?.name,
                              )}
                            </span>
                            <span className="infoTeacher">
                              {t("SINCE")}:{" "}
                              {t(moment(userClass?.teacher?.createdAt).format("MMMM").toUpperCase()) +
                                "/" +
                                moment(userClass?.teacher?.createdAt).format("YYYY")}
                            </span>
                          </div>
                        </div>
                      )}

                      <div className="rowItem">
                        <FlagIcon code={userClass?.lingoLanguage?.flag} />
                        <div className="columnItem">
                          <label>{t("LANGUAGE")}</label>
                          <span>{t(userClass?.lingoLanguage?.description.toUpperCase())}</span>
                        </div>
                      </div>
                      <div className="rowItem timezone">
                        <div className="columnItem dateItem">
                          <label>{t("TIMEZONE")}</label>
                          <span className="lineBlue">{t("STUDENT")}</span>
                          {userClass.teacher && status === "done" && <span>{t("TEACHER")}</span>}
                          {user?.role === "companyManager" && <span>{t("CM")}</span>}
                          {user?.role === "customerService" && <span>{t("CS")}</span>}
                        </div>

                        <div className="columnItem dateItem">
                          <label>{t("DATE")}</label>
                          <span className="lineBlue">
                            {userClass?.scheduledStartDateTime &&
                              momentTimezone(
                                userTimezoneConvert(userClass?.scheduledStartDateTime, user),
                                t("DATE_FORMAT"),
                              ).format(t("DATE_FORMAT"))}
                          </span>

                          {userClass?.teacher?.user && status === "done" && (
                            <span>
                              {userClass?.scheduledStartDateTime &&
                                momentTimezone(
                                  userTimezoneConvert(userClass?.scheduledStartDateTime, userClass?.teacher?.user),
                                  t("DATE_FORMAT"),
                                ).format(t("DATE_FORMAT"))}
                            </span>
                          )}
                        </div>
                        <div className="columnItem dateItem">
                          <label>{t("START")}</label>
                          <span className="lineBlue">
                            {userClass?.scheduledStartDateTime &&
                              momentTimezone(
                                userTimezoneConvert(userClass?.scheduledStartDateTime, userClass?.student?.user),
                                "HH:mm:ss",
                              ).format(timeDisplayFormat(user?.timeDisplayFormat))}
                          </span>
                          {userClass.teacher && status === "done" && (
                            <span>
                              {momentTimezone(
                                userTimezoneConvert(userClass?.scheduledStartDateTime, userClass?.teacher?.user),
                                "HH:mm:ss",
                              ).format(timeDisplayFormat(user?.timeDisplayFormat))}
                            </span>
                          )}
                          {(user?.role === "companyManager" || user?.role === "customerService") && (
                            <span>
                              {momentTimezone(
                                userTimezoneConvert(userClass?.scheduledStartDateTime, user),
                                "HH:mm:ss",
                              ).format(timeDisplayFormat(user?.timeDisplayFormat))}
                            </span>
                          )}
                        </div>
                        <div className="columnItem dateItem">
                          <label>{t("END")}</label>
                          <span className="lineBlue">
                            {userClass?.scheduledStartDateTime &&
                              momentTimezone(
                                userTimezoneConvert(userClass?.scheduledStartDateTime, userClass?.student?.user).add(
                                  userClass?.sequentialSchedule === false
                                    ? 30
                                    : 30 * userClass?.sequentialScheduleClassesCount,
                                  "minutes",
                                ),
                                "HH:mm:ss",
                              ).format(timeDisplayFormat(user?.timeDisplayFormat))}
                          </span>
                          {userClass.teacher && status === "done" && (
                            <span>
                              {momentTimezone(
                                userTimezoneConvert(userClass.scheduledStartDateTime, userClass?.teacher?.user).add(
                                  userClass.sequentialSchedule === false
                                    ? 30
                                    : 30 * userClass.sequentialScheduleClassesCount,
                                  "minutes",
                                ),
                                "HH:mm:ss",
                              ).format(timeDisplayFormat(user?.timeDisplayFormat))}
                            </span>
                          )}
                          {(user?.role === "companyManager" || user?.role === "customerService") && (
                            <span>
                              {momentTimezone(
                                userTimezoneConvert(userClass.scheduledStartDateTime, user).add(
                                  userClass.sequentialSchedule === false
                                    ? 30
                                    : 30 * userClass.sequentialScheduleClassesCount,
                                  "minutes",
                                ),
                                "HH:mm:ss",
                              ).format(timeDisplayFormat(user?.timeDisplayFormat))}
                            </span>
                          )}
                        </div>
                      </div>
                      {status === "done" ? (
                        <div className="columnItem">
                          <div className="columnItem">
                            <label>{t("DURATION")}</label>
                            <span>{handleCalcDuration(userClass?.sequentialScheduleClassesCount)}</span>
                          </div>
                          <div className="columnItem">
                            <label>{t("FOCUS")}</label>
                            <span>{focus}</span>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="columnItem dateItem">
                            <label>{t("DURATION")}</label>
                            <span>{handleCalcDuration(userClass?.sequentialScheduleClassesCount)}</span>
                          </div>
                          <div className="columnItem dateItem">
                            <label>{t("FOCUS")}</label>
                            <span>{focus}</span>
                          </div>
                        </>
                      )}
                      {focus === "specific" && <textarea readOnly value={specificSubject} />}
                    </div>
                  </div>
                )}

                {user?.role !== "student" && (
                  <div className="listSelect">
                    <div className="rowInfo">
                      <div className="rowItem timezone">
                        <div className="columnItem">
                          {userClass.student && userClass?.student?.user?.picture ? (
                            <img className="imgTeacher" src={userClass.student.user.picture} alt="" />
                          ) : userClass.student && userClass?.student?.picture ? (
                            <img className="imgTeacher" src={userClass?.student?.picture} alt="" />
                          ) : (
                            <img className="imgTeacher" src={IconAvatar} alt="" />
                          )}
                          {checkBirthdayDate(userClass?.student?.user?.birthDate) && (
                            <img className="iconBirthday" src={IconBirthday} alt="" />
                          )}
                        </div>
                        <div className="columnItem dateItem">
                          <span className="nameTeacher">{decryptIfEncrypted(userClass?.student?.user?.name)}</span>
                          <span className="infoTeacher green">{t("STUDENT")}</span>
                          {userClass?.student?.studentLanguages &&
                            userClass?.student?.studentLanguages
                              ?.filter((lang) => lang.isNative)
                              ?.map((itemStudentLang) => {
                                return (
                                  <span key={JSON.stringify(itemStudentLang)} className="infoTeacher">
                                    {t("NATIVE_LANGUAGE")}:{" "}
                                    {t(decryptIfEncrypted(itemStudentLang.language.name).toUpperCase())}
                                  </span>
                                );
                              })}

                          <span className="infoTeacher">
                            {t("COUNTRY")}:{" "}
                            {decryptIfEncrypted(
                              userClass?.student?.country
                                ? userClass?.student?.country?.name
                                : userClass?.student?.user?.country?.name,
                            )}
                          </span>
                          <span className="infoTeacher">
                            {t("SINCE")}:{" "}
                            {t(moment(userClass?.student?.createdAt).format("MMMM").toUpperCase()) +
                              "/" +
                              moment(userClass?.student?.createdAt).format("YYYY")}
                          </span>
                        </div>
                      </div>

                      <div className="rowItem">
                        <FlagIcon code={userClass?.lingoLanguage?.flag} />
                        <div className="columnItem">
                          <label>{t("LANGUAGE")}</label>
                          <span>{t(userClass?.lingoLanguage?.description.toUpperCase())}</span>
                        </div>
                      </div>

                      <div className="rowItem timezone">
                        <div className="columnItem dateItem">
                          <label>{t("TIMEZONE")}</label>
                          <span className="lineBlue">{t("STUDENT")}</span>
                          {userClass?.teacher && <span>{t("TEACHER")}</span>}

                          {user?.role === "companyManager" && <span>{t("CM")}</span>}
                          {user?.role === "customerService" && <span>{t("CS")}</span>}
                        </div>

                        <div className="columnItem dateItem">
                          <label>{t("DATE")}</label>
                          <span className="lineBlue">
                            {userClass?.scheduledStartDateTime &&
                              momentTimezone(
                                userTimezoneConvert(userClass?.scheduledStartDateTime, userClass?.student?.user),
                                t("DATE_FORMAT"),
                              ).format(t("DATE_FORMAT"))}
                          </span>

                          {userClass?.teacher?.user && (
                            <span>
                              {userClass?.scheduledStartDateTime &&
                                momentTimezone(
                                  userTimezoneConvert(userClass?.scheduledStartDateTime, userClass?.teacher?.user),
                                  t("DATE_FORMAT"),
                                ).format(t("DATE_FORMAT"))}
                            </span>
                          )}
                          {!userClass?.teacher?.user && userClass?.teacher && (
                            <span>
                              {userClass?.scheduledStartDateTime &&
                                momentTimezone(
                                  userTimezoneConvert(userClass?.scheduledStartDateTime, userClass?.teacher),
                                  t("DATE_FORMAT"),
                                ).format(t("DATE_FORMAT"))}
                            </span>
                          )}
                          {(user?.role === "companyManager" || user?.role === "customerService") && (
                            <span>
                              {momentTimezone(
                                userTimezoneConvert(userClass?.scheduledStartDateTime, user),
                                t("DATE_FORMAT"),
                              ).format(t("DATE_FORMAT"))}
                            </span>
                          )}
                        </div>

                        <div className="columnItem dateItem">
                          <label>{t("START")}</label>
                          <span className="lineBlue">
                            {userClass?.scheduledStartDateTime &&
                              momentTimezone(
                                userTimezoneConvert(userClass?.scheduledStartDateTime, userClass?.student?.user),
                                "HH:mm:ss",
                              ).format(timeDisplayFormat(user?.timeDisplayFormat))}
                          </span>

                          {userClass?.teacher?.user && (
                            <span>
                              {momentTimezone(
                                userTimezoneConvert(userClass?.scheduledStartDateTime, userClass?.teacher?.user),
                                "HH:mm:ss",
                              ).format(timeDisplayFormat(user?.timeDisplayFormat))}
                            </span>
                          )}
                          {!userClass?.teacher?.user && userClass?.teacher && (
                            <span>
                              {momentTimezone(
                                userTimezoneConvert(userClass?.scheduledStartDateTime, userClass?.teacher),
                                "HH:mm:ss",
                              ).format(timeDisplayFormat(user?.timeDisplayFormat))}
                            </span>
                          )}
                          {(user?.role === "companyManager" || user?.role === "customerService") && (
                            <span>
                              {momentTimezone(
                                userTimezoneConvert(userClass?.scheduledStartDateTime, user),
                                "HH:mm:ss",
                              ).format(timeDisplayFormat(user?.timeDisplayFormat))}
                            </span>
                          )}
                        </div>
                        <div className="columnItem dateItem">
                          <label>{t("END")}</label>
                          <span className="lineBlue">
                            {userClass?.scheduledStartDateTime &&
                              momentTimezone(
                                userTimezoneConvert(userClass?.scheduledStartDateTime, userClass?.student?.user).add(
                                  userClass?.sequentialSchedule === false
                                    ? 30
                                    : 30 * userClass?.sequentialScheduleClassesCount,
                                  "minutes",
                                ),
                                "HH:mm:ss",
                              ).format(timeDisplayFormat(user?.timeDisplayFormat))}
                          </span>

                          {userClass?.teacher?.user && (
                            <span>
                              {momentTimezone(
                                userTimezoneConvert(userClass?.scheduledStartDateTime, userClass?.teacher?.user).add(
                                  userClass?.sequentialSchedule === false
                                    ? 30
                                    : 30 * userClass?.sequentialScheduleClassesCount,
                                  "minutes",
                                ),
                                "HH:mm:ss",
                              ).format(timeDisplayFormat(user?.timeDisplayFormat))}
                            </span>
                          )}
                          {!userClass?.teacher?.user && userClass?.teacher && (
                            <span>
                              {momentTimezone(
                                userTimezoneConvert(userClass?.scheduledStartDateTime, userClass?.teacher).add(
                                  userClass?.sequentialSchedule === false
                                    ? 30
                                    : 30 * userClass?.sequentialScheduleClassesCount,
                                  "minutes",
                                ),
                                "HH:mm:ss",
                              ).format(timeDisplayFormat(user?.timeDisplayFormat))}
                            </span>
                          )}
                          {(user?.role === "companyManager" || user?.role === "customerService") && (
                            <span>
                              {momentTimezone(
                                userTimezoneConvert(userClass.scheduledStartDateTime, user).add(
                                  userClass.sequentialSchedule === false
                                    ? 30
                                    : 30 * userClass.sequentialScheduleClassesCount,
                                  "minutes",
                                ),
                                "HH:mm:ss",
                              ).format(timeDisplayFormat(user?.timeDisplayFormat))}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="columnItem">
                        <div className="columnItem mb7">
                          <label>{t("DURATION")}</label>
                          <span>{handleCalcDuration(userClass?.sequentialScheduleClassesCount)}</span>
                        </div>
                        <div className="columnItem">
                          <label>{t("FOCUS")}</label>
                          <span>{focus}</span>
                        </div>
                      </div>
                      {(user?.role === "companyManager" || user?.role === "customerService") && userClass.teacher ? (
                        <div className="rowItem timezone">
                          <div className="columnItem">
                            {userClass.teacher && userClass?.teacher?.user?.picture ? (
                              <img className="imgTeacher" src={userClass.teacher.user.picture} alt="" />
                            ) : userClass.teacher && userClass?.teacher?.picture ? (
                              <img className="imgTeacher" src={userClass?.teacher?.picture} alt="" />
                            ) : (
                              <img className="imgTeacher" src={IconAvatar} alt="" />
                            )}
                            {checkBirthdayDate(
                              userClass?.teacher?.user?.birthDate
                                ? userClass?.teacher?.user?.birthDate
                                : userClass?.teacher?.birthDate,
                            ) && <img className="iconBirthday" src={IconBirthday} alt="" />}
                          </div>
                          <div className="columnItem dateItem">
                            <span className="nameTeacher">
                              {decryptIfEncrypted(
                                userClass?.teacher?.user?.name
                                  ? userClass?.teacher?.user?.name
                                  : userClass?.teacher?.name,
                              )}
                            </span>
                            <span className="infoTeacher green">{t("TEACHER")}</span>
                            {userClass?.teacher?.teacherLanguages &&
                            userClass?.teacher?.teacherLanguages?.filter(
                              (lang) =>
                                lang.isNative &&
                                lang.language.name.toUpperCase() ===
                                  userClass?.lingoLanguage?.description.toUpperCase(),
                            ).length > 1 ? (
                              <span className="infoTeacher">
                                {t("NATIVE_LANGUAGE")}:{" "}
                                {userClass?.teacher?.teacherLanguages &&
                                  userClass?.teacher?.teacherLanguages
                                    ?.filter(
                                      (lang) =>
                                        lang.isNative &&
                                        lang.language.name.toUpperCase() ===
                                          userClass?.lingoLanguage?.description.toUpperCase(),
                                    )
                                    ?.map((itemStudentLang) => {
                                      return t(decryptIfEncrypted(itemStudentLang.language.name).toUpperCase());
                                    })}
                              </span>
                            ) : userClass?.teacher?.teacherLanguages ? (
                              userClass?.teacher?.teacherLanguages
                                ?.filter(
                                  (lang) =>
                                    lang.isNative &&
                                    lang.language.name.toUpperCase() ===
                                      userClass?.lingoLanguage?.description.toUpperCase(),
                                )
                                ?.map((itemTeacherLang) => {
                                  return (
                                    <span key={JSON.stringify(itemTeacherLang)} className="infoTeacher">
                                      {t("NATIVE_LANGUAGE")}:{" "}
                                      {t(decryptIfEncrypted(itemTeacherLang.language.name).toUpperCase())}
                                    </span>
                                  );
                                })
                            ) : (
                              userClass?.teacher?.teachers[0]?.teacherLanguages
                                ?.filter(
                                  (lang) =>
                                    lang.isNative &&
                                    lang.language.name.toUpperCase() ===
                                      userClass?.lingoLanguage?.description.toUpperCase(),
                                )
                                ?.map((itemTeacherLang) => {
                                  return (
                                    <span key={JSON.stringify(itemTeacherLang)} className="infoTeacher">
                                      {t("NATIVE_LANGUAGE")}:{" "}
                                      {t(decryptIfEncrypted(itemTeacherLang.language.name).toUpperCase())}
                                    </span>
                                  );
                                })
                            )}

                            <span className="infoTeacher">
                              {t("COUNTRY")}:{" "}
                              {decryptIfEncrypted(
                                userClass?.teacher?.country
                                  ? userClass?.teacher?.country?.name
                                  : userClass?.teacher?.user?.country?.name,
                              )}
                            </span>
                            <span className="infoTeacher">
                              {t("SINCE")}:{" "}
                              {t(moment(userClass?.teacher?.createdAt).format("MMMM").toUpperCase()) +
                                "/" +
                                moment(userClass?.teacher?.createdAt).format("YYYY")}
                            </span>
                          </div>
                        </div>
                      ) : (
                        focus === "specific" && (
                          <textarea readOnly>{userClass?.classScheduleDetails[0]?.specificSubject}</textarea>
                        )
                      )}
                    </div>
                  </div>
                )}

                <div className="rowClass">
                  <div className="leftDiv">
                    {!customLanguage && <CardWordoftheday level={levelStudent} />}
                    {customLanguage && (
                      <button onClick={handleOpenModalQuestionnaires} className="btnOpenModal">
                        {t("OPEN_MODAL_QUESTIONNAIRES")}
                      </button>
                    )}
                    {user.role !== "student" && <CardLatestSchedule />}
                  </div>

                  {user?.role !== "student" && (
                    <div className="classRun">
                      <div className="sideContent">
                        {allPreviousClasses?.length > 0 && <h4 className="title">{t("PREVIOUS_CLASSES")}</h4>}

                        <div className="divContent">
                          {allPreviousClasses?.length > 0 &&
                            allPreviousClasses
                              ?.slice(-3)
                              .map((item, index) => (
                                <CardPreviousClasses
                                  key={index}
                                  data={item}
                                  index={index}
                                  length={allPreviousClasses?.length}
                                  sequentialScheduleId={sequentialScheduleId}
                                />
                              ))}
                        </div>

                        <div className="headerContent">
                          <h4 className="title">{t("BTN_UPCOMING_CLASS")}</h4>
                          {/* <BiSolidError color="#ff1600" size={30} /> */}
                        </div>

                        <div className="divContent">
                          {allNextClasses
                            ?.filter((item) => item !== null)
                            ?.slice(0, moreClassLimit)
                            ?.map((item, index) => (
                              <CardNextClasses key={index} data={item} sequentialScheduleId={sequentialScheduleId} />
                            ))}

                          {moreClassLimit !== 10 && (
                            <div className="buttonMoreClass" onClick={handleMoreContent}>
                              <button>{t("MORE_CLASSES")}</button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {user.role !== "student" && (
                  <>
                    {canSeeNoShowSwitch && (
                      <div>
                        <hr />
                        <div className="classInfo">
                          <h2>{t("CARD_CLASS_DETAILS")}</h2>

                          <div className="infoItem">
                            <div className="item">
                              <h3>{t("CARD_CLASS_ATTENDED")}</h3>
                              <div className="switchBox">
                                <div className="switch__container">
                                  <input
                                    id="switch-shadow"
                                    className="switch switch--shadow"
                                    name="noShow"
                                    type="checkbox"
                                    checked={noShow}
                                    onChange={handleChangeStatus}
                                  />
                                  <label htmlFor="switch-shadow">
                                    <span style={{ marginLeft: "50px", fontSize: "12px" }}>
                                      {noShow ? t("YES") : t("NO")}
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr />
                      </div>
                    )}

                    {/* {status === "canceled" && classScheduleDetails && (
                      <div className="cancel">
                        <h2>{t("CARD_CLASS_CANCEL")}</h2>
                        <div className="boxWhite">
                          {classScheduleDetails.map((classDetail, index) => (
                            <div className="boxItem" key={index * 8}>
                              <div className="infos">
                                <div className="text">
                                  <div className="name"> {t("CARD_CLASS_CANCELLED")}</div>
                                  <div className="Reason">
                                    <strong>{t("CARD_CLASS_REASON")}:</strong> {classDetail.canceledDetails}
                                  </div>
                                  <span>
                                    <strong>{t("DATA_TIME")}:</strong>{" "}
                                    {userTimezoneConvert(classDetail.updatedAt, user).format(
                                      t("DATE_FORMAT") + " - hh:mm A",
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <hr />
                      </div>
                    )} */}

                    {status === "canceledLingo" ||
                      (status === "canceledFreeLingo" && classScheduleDetails && (
                        <div className="cancel">
                          <h2>{t("CARD_CLASS_CANCEL")}</h2>
                          <div className="boxWhite">
                            {classScheduleDetails.map((classDetail, index) => (
                              <div className="boxItem" key={index * 8}>
                                <div className="infos">
                                  <div className="text">
                                    <div className="name"> {t("CARD_CLASS_CANCELLED")}</div>
                                    <div className="Reason">
                                      <strong>{t("CARD_CLASS_REASON")}:</strong> {classDetail.canceledDetails}
                                    </div>
                                    <span>
                                      <strong>{t("DATA_TIME")}:</strong>{" "}
                                      {userTimezoneConvert(classDetail.updatedAt, user).format(
                                        t("DATE_FORMAT") + " - hh:mm A",
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          <hr />
                        </div>
                      ))}
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </section>

      {showModalCoordinator && (
        <ModalMessageCoordinator
          showModalCoordinator={showModalCoordinator}
          setShowModalCoordinator={setShowModalCoordinator}
        />
      )}

      {showModalQuestionnaires && (
        <ModalQuestionnairesView
          userId={userId}
          showModal={showModalQuestionnaires}
          setShowModal={setShowModalQuestionnaires}
        />
      )}

      <Dialog
        open={openalert}
        className="boxModal"
        onClose={() => setOpenAlert(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <span className="titleModal">{alerttitle}</span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="pass-dialog-description" className="boxModal">
            <span className="formulario">
              <span className="description">{alertdescription}</span>
            </span>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <div className="buttons">
            <button onClick={() => setOpenAlert(false)} color="primary" autoFocus>
              {t("CLOSE")}
            </button>
          </div>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openalertStatus}
        className="boxModal"
        onClose={() => setOpenAlert(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <span className="titleModal">{alerttitleStatus}</span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="pass-dialog-description" className="boxModal">
            <span className="formulario">
              <span className="description">
                {t("NOSHOW_MESSAGE_MODAL", {
                  status: noShow
                    ? t("CLASS_SUB_NOSHOW")
                    : teacherId
                    ? t("CLASS_SUB_CONFIRMED")
                    : t("CLASS_SUB_PENDING"),
                })}
              </span>
            </span>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <div className="buttons">
            <button
              onClick={() => {
                setNoShow(!noShow);
                setOpenAlertStatus(false);
              }}
              color="primary"
              autoFocus
            >
              {t("BTN_CLOSE")}
            </button>
            <button onClick={(e) => handleSubmitStatus(e)} color="primary" autoFocus>
              {t("BTN_CONFIRM")}
            </button>
          </div>
        </DialogActions>
      </Dialog>

      {openSchedule && (
        <ModalSchedule
          planId={planId}
          noShow={noShow}
          editClass={true}
          title="Alterar aula"
          teacherId={teacherId}
          studentId={studentId}
          userClass={userClass}
          openSchedule={openSchedule}
          closeSchedule={() => setOpenSchedule(false)}
          sequentialScheduleId={sequentialScheduleId}
        />
      )}

      <CancelDialog
        classes={[]}
        cancelSubmit={cancelSubmit}
        allSeqClasses={allSeqClasses}
        openCancelAlert={cancelAlertOpen}
        closeCancelAlert={closeCancelAlert}
        recurrentSchedule={recurrentSchedule}
        recurrentScheduleId={recurrentScheduleId}
        recurrentScheduleEndDate={recurrentScheduleEndDate}
        sequentialScheduleCancelClasses={sequentialScheduleCancelClasses}
      />
    </div>
  );
}

export default ClassDetails;
